

import Box from 'vux/src/components/box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
name: 'Policy',
props: ['merchant'],
components: {
Box,
Cell,
XHeader,
XButton,
},
data() {
return {
};
},
computed: {
tenantName() {
return this.merchant === "JKL" ? '京客隆': '票易通';
},
},
created() {















},
};
